// Persistente „externe Inhalte (Bilder) immer laden"-Allowlist (T1) pro Absender
// bzw. Domäne. Speicherung in localStorage (gerätegebunden, KEINE DB-Migration).
// Tracking-Schutz bleibt Default: nur ausdrücklich freigegebene Absender/Domänen
// laden Remote-Inhalte automatisch; alle anderen bleiben blockiert bis „Anzeigen".
//
// Einträge: nackte Absenderadresse ("a@b.de") ODER Domäne mit führendem "@"
// ("@b.de").

const KEY = "mail.remoteAllow";

function read(): string[] {
    try {
        const raw = localStorage.getItem(KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === "string") : [];
    } catch {
        return [];
    }
}

function write(list: string[]): void {
    try {
        localStorage.setItem(KEY, JSON.stringify(Array.from(new Set(list))));
    } catch {
        // ignore (Quota/SecurityError) — Default bleibt „blockiert"
    }
}

function domainOf(email: string): string | null {
    const at = (email || "").lastIndexOf("@");
    return at >= 0 && at < email.length - 1 ? email.slice(at + 1).toLowerCase() : null;
}

/** true, wenn für diesen Absender (oder seine Domäne) Remote-Inhalte freigegeben sind. */
export function isRemoteAllowed(senderEmail: string | null | undefined): boolean {
    const e = (senderEmail || "").trim().toLowerCase();
    if (!e) return false;
    const list = read();
    if (list.includes(e)) return true;
    const dom = domainOf(e);
    return !!dom && list.includes("@" + dom);
}

/** Diesen Absender dauerhaft für Remote-Inhalte freigeben. */
export function allowRemoteSender(senderEmail: string | null | undefined): void {
    const e = (senderEmail || "").trim().toLowerCase();
    if (e) write([...read(), e]);
}

/** Die ganze Domäne des Absenders dauerhaft freigeben. */
export function allowRemoteDomain(senderEmail: string | null | undefined): void {
    const dom = domainOf((senderEmail || "").trim().toLowerCase());
    if (dom) write([...read(), "@" + dom]);
}
